import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { Loading } from "../../components/Elements/Loading";

const LoginPage = lazy(() => import(`./LoginPage`));

const AuthViews = () => {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route
          path="/login"
          element={<LoginPage title="Login to your account" />}
        />
      </Routes>
    </Suspense>
  );
};

export default AuthViews;
